import { createTheme } from "@mui/material/styles";
import { getAccountId, getPrimaryColorByAccountId, getThemeByAccountId } from "./styleConstants";

export const createAppTheme = (store: any) => {

  const accountId = getAccountId()
          
  const primaryColor = getPrimaryColorByAccountId(accountId);
  const themeByAccountId = getThemeByAccountId(accountId);

  let bgColorDefault = "#000";
  let textColorDefault = "#FFF";

  if (themeByAccountId === 'light') {
    bgColorDefault = '#FFF'
    textColorDefault = "#000";
  }

  return createTheme({
    typography: {
      fontFamily: "Poppins",
    },
    palette: {
      mode: themeByAccountId,
      primary: {
        main: primaryColor,
      },
      background: {
        default: bgColorDefault,
      },
      secondary: {
        main: "#d82020",
      },
      success: {
        main: "#38A121",
      },
    },
    components: {
      MuiDialogContent: {
        styleOverrides: {
          root: {
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          },
        },
      },
      MuiDialogActions: {
        styleOverrides: {
          root: {
            justifyContent: "center",
            padding: "1.5rem",
            "& :not(:first-of-type)": {
              marginLeft: 24,
            },
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            color: textColorDefault
          }
        }
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiInputBase-input': {
              color: themeByAccountId === 'dark' ? '#fff' : '#000'
            },
            '& .MuiInput-underline:before': {
              borderBottomColor: themeByAccountId === 'dark' ? '#fff' : '#000'
            },
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
              borderBottomColor: themeByAccountId === 'dark' ? '#fff' : '#000'
            },
            '& .MuiInput-underline:after': {
              borderBottomColor: themeByAccountId === 'dark' ? '#fff' : '#000'
            },
            '& .MuiInputBase-input::placeholder': {
              color: themeByAccountId === 'dark' ? '#fff' : '#000'
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: "8px",
            boxShadow: "none",
            cursor: "pointer",
          },
          contained: {
            textTransform: "initial",
          },
        },
      },
    },
  })
};

